export default "__VITE_ASSET__C3H9xeq4__";